import { AwsConfig as AwsConstants } from '@services/Constants';

import BaseService, { RequestInterface } from '@services/Base';
import IPagination from '@interfaces/IPagination';
import Ticket from '@interfaces/ehss/ticket';
import TicketPaginationQuery from '@interfaces/ehss/ticket-pagination-query';
import TaskflowValue from '@interfaces/taskflow-value';
import IProcessValue from '@components/FormFlow/Interfaces/IProcessValue';

export default class TicketQAService extends BaseService {
  constructor() {
    super(AwsConstants.API_QA, 'ticket');
  }

  async getById(id: string, unit: string, fields?: string[]): Promise<Ticket> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    params.queryStringParameters['unit'] = unit;
    const res = await super.get<Ticket>(id, params);
    return res;
  }
  async notificationExec(id: string, eventId: string): Promise<void> {
    await super.patch<void>(`${id}/notification/${eventId}`);
  }
  async processExec(id: string, eventId: string, data: IProcessValue): Promise<void> {
    const params: RequestInterface = {
      body: data
    };
    await super.patch<void>(`${id}/process/${eventId}`, params);
  }
  async start(workflowId: string, distributorId: string, unitId: string, data: TaskflowValue): Promise<Ticket> {
    const params: RequestInterface = {
      queryStringParameters: { distributor: distributorId, unit: unitId },
      body: data
    };
    const res = await super.patch<Ticket>(`workflow/${workflowId}`, params);
    return res;
  }

  async paging(query: TicketPaginationQuery, fields?: string[]): Promise<IPagination<Ticket>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }
    if (query.from != null) {
      params.queryStringParameters['from'] = query.from;
    }
    if (query.to != null) {
      params.queryStringParameters['to'] = query.to;
    }
    if (query.status != null) {
      params.queryStringParameters['status'] = query.status;
    }
    if (query.orderBy) {
      params.queryStringParameters['orderBy'] = query.orderBy;
    }
    if (query.disable) {
      params.queryStringParameters['disable'] = query.disable;
    }
    if (query.fieldId && query.fieldValue) {
      params.queryStringParameters['field'] = query.fieldId;
      params.queryStringParameters['value'] = query.fieldValue;
    }
    if (query.process) {
      params.queryStringParameters['process'] = query.process;
    }
    if (query.component) {
      params.queryStringParameters['component'] = query.component;
    }

    if (query.search) {
      params.queryStringParameters['search'] = query.search;
    }

    const res = await super.get<IPagination<Ticket>>(``, params);
    return res;
  }


  async my(unitId: string, query: TicketPaginationQuery, fields?: string[]): Promise<IPagination<Ticket>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    params.queryStringParameters['unit'] = unitId;
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }

    const res = await super.get<IPagination<Ticket>>('my', params);
    return res;
  }

  async filetTicket(id: string, isField: boolean): Promise<Ticket> {

    const res = await super.put<Ticket>(`${id}/disable/${isField}`);
    return res;
  }
}